
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".707","y":".5","width":"54","height":"43","rx":"4.5","fill":"#27A6BD","stroke":"#CED4DA"}}),_c('path',{attrs:{"fill":"#fff","d":"M24.875 12h6.667v20h-6.667zM17.207 23h6v9h-6zM33.207 19h6v13h-6z"}})])
          )
        }
      }
    